import DistributorDashboard from './DistributorDashboard';
import { UnderConstructionPage } from '../pages/underConstruction/UnderConstructionPage';
import { ErrorBoundary } from '../components/containers/ErrorBoundary';

/**
 * App
 * ---
 * The app root, and the on/off switch for the whole dashboard.
 *
 * `UNDER_CONSTRUCTION` swaps the entire app for a holding page. The switch sits here, above
 * the router, on purpose: darkening the dashboard has to catch users who are already signed
 * in — and the login page itself — not just individual screens.
 *
 * It is currently **off**: the dashboard is live.
 *
 * The holding page is kept rather than deleted because the reason it existed has not gone
 * away — the distributor→channel billing rework moves the revenue split onto the order line,
 * so the per-distributor figures this app renders are still liable to change meaning when
 * that redesign lands. If we need to take the dashboard down again, flip this to true; the
 * router and every route below it stay untouched either way.
 */

const UNDER_CONSTRUCTION: boolean = false;

function App() {
  return (
    <div className="App">
      <ErrorBoundary fullPage>
        {UNDER_CONSTRUCTION ? <UnderConstructionPage /> : <DistributorDashboard />}
      </ErrorBoundary>
    </div>
  );
}

export default App;
